import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import Greet from '../components/Greet';
import TimezoneDropdown from "./TimezoneDropdown";
import TimezoneSelect from 'react-timezone-select';
import './Profile.css';
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import AWS from "aws-sdk";
var config = require("../../src/config/dev").default;
const { S3Client, GetObjectCommand } = require('@aws-sdk/client-s3');


const Profile = (props) => {
    let [imageSrc, setImageSrc] = useState(
        "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
        );
    // const [imageSrc, setImageSrc] = useState("");

      const [selectedTimezone, setSelectedTimezone] = useState({label: 'UTC', value: 'UTC'});
      const [phoneNumberError, setPhoneNumberError] = useState('');
      const [localDate1, setLocalDate1] = useState('');
      const [localTime1, setLocalTime1] = useState('');
      const [profileImg1, setprofileImg1] = useState('');
      let utcTimestamp1 = "";
      // let localDate1 = "";
      // let localTime1 = "";
      const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        timeZone: 'UTC',
        phoneNumber: "",
        createdAt : "",
        profileImg: "",
      });
    // const params = useParams();
    const orgId =  sessionStorage.getItem("organizationId");
    const deptId = sessionStorage.getItem("departmentId");
	const affId = sessionStorage.getItem("affiliateId");
    console.log("orgId",orgId);
    console.log("deptId",deptId);
    console.log("affId",affId);
    const loggedIn = sessionStorage.getItem("LoggedIn");
    console.log("loggedIn",loggedIn);
    const id = sessionStorage.getItem("Id");
    // const firstname = sessionStorage.getItem("firstName");
    // const lastname = sessionStorage.getItem("lastName");
    // const email = sessionStorage.getItem("email");
    // const timeZone = sessionStorage.getItem("timeZone");
    // const phoneNumber = sessionStorage.getItem("phoneNumber");
    // const createdAt = sessionStorage.getItem("createdAt");
    console.log("id",id);
    const user_id = { id }
    const [user,setUser] = useState({});
    useEffect(()=>{
        const fetchUser = async()=>{

            axios.get(config.API_ENDPOINT+"api/v1/user/"+id,{
                method:"get",
                headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
                      
              }).then((response) => {
                
                console.log("response",response);
                setUser("response.data",response.data);
                // console.log(response.status);
                // console.log(response.data);
                const userData = response.data.data;
                console.log("userdata",userData);
                setFormData({
                firstName: userData.firstName,
                lastName: userData.lastName,
                email: userData.email,
                timeZone: userData.timeZone,
                phoneNumber: userData.phoneNumber,
                createdAt : userData.createdAt,
                profileImg:userData.profileImg
                });
                // setImageSrc(userData.profileImg || imageSrc);
                console.log("created Date", userData.createdAt);
                utcTimestamp1 = new Date(userData.createdAt);
                console.log("utcTimestamp1",utcTimestamp1);
                const date1 = utcTimestamp1.toLocaleDateString()
                const time1 = utcTimestamp1.toLocaleTimeString()
                console.log("localTimestamp11",date1 , time1);
                setLocalDate1(date1);
                setLocalTime1(time1);
                console.log("dateTime",localDate1,localTime1);
                setSelectedTimezone({ value: userData.timeZone, label: 'UTC' });
                setprofileImg1(userData.profileImg);
                // Show saved profile photo on load (was commented out — bug fix)
                if (userData.profileImg) setImageSrc(userData.profileImg);
                // console.log("selectedtzinuseEffect:",selectedTimezone);
      
                });
        }
        fetchUser();
    },[]);
    // console.log("user->",user);
    // const handleTimezoneChange = (selectedOption) => {
    //   setSelectedTimezone(selectedOption);
    // };

    // const handleTimezoneChange = (timezone) => {
    //   setFormData({ ...formData, timeZone: timezone.value });
    // };

    // const TimeZoneSelector = () => {
    //   const [selectedTimezone, setSelectedTimezone] = useState({
    //     label: 'UTC',
    //     value: 'UTC',
    //   })}

    // Returns a Promise that resolves with the S3 public URL on success
    const uploadFile = (file, filename) => {
      return new Promise((resolve, reject) => {
        const s3 = new AWS.S3({
          accessKeyId: "AKIA2JDSZ5DE2NYBCANH",
          secretAccessKey: "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",
          region: "ap-south-1",
          signatureVersion: "v4",
        });
        const params = {
          Bucket: 'tracechain-2026',
          Key: filename,
          Body: file,
          ACL: 'public-read',
          ContentType: file.type,
        };
        s3.upload(params, (err, data) => {
          if (err) { console.error("S3 upload error:", err); reject(err); }
          else resolve(data.Location);
        });
      });
    };

    const validatePhoneNumber = (number) => {
      // Simple example: Check if the phone number is not empty
      if (!number.trim()) {
        return 'Phone number is required.';
      }
    
      // Define a regular expression pattern for a valid phone number
      const phonePattern = /^[0-9]{10}$/;

      // Check if the phone number matches the pattern
      if (!phonePattern.test(number)) {
        return 'Please enter a valid 10-digit phone number.';
      }

      // You can add more complex validation logic here
    
      return ''; // No validation error
    };
    

    const handleTimezoneChange = (timezone) => {
      if (timezone && timezone.value) {
        setFormData({ ...formData, timeZone: timezone.value });
        // setSelectedTimezone({ ...formData, timeZone: timezone.value });
      }
    };
    

    const handleFormSubmit = (e) => {
        document.getElementById("confirmspin").style.display = "block"
        e.preventDefault();
       // Update formData with the selected timezone value
       const updatedFormData = { ...formData, timeZone: selectedTimezone.valueOf }; // Update timeZone with selectedTimezone value
        // Send a PUT or POST request to update user data on the server
        axios
          .put(config.API_ENDPOINT + "api/v1/user/" + id+"?organizationId="+orgId+"&departmentId="+deptId+"&affiliateId="+affId, formData,{
            method:"put",
            headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
            }).then((response) => {
            if (response.data.success) {
              // Handle success
              console.log("User update success:", response.data.success);
              toast.success("Profile Saved Successfully!!", {
                position:'top-center',
                autoClose:3000,
                onClose: () => {window.location.reload()}
             });
              
            } else {
              // Handle error
              console.log("User update failed:", response.data.error);
            }
          })
          .catch((error) => {
            console.log("User update error:", error);
          });
      };
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        // setFormData({ ...formData, [name]: selectedTimezone.value });

        // Validate phone number and update error state
        const error = validatePhoneNumber(value);
        setPhoneNumberError(error);

      };

      const Cancel = () => {
        window.location.href = '/home';
      };

    const handleImageUpload = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      // 1. Show local preview immediately (no wait for S3)
      const reader = new FileReader();
      reader.onload = (evt) => setImageSrc(evt.target.result);
      reader.readAsDataURL(file);

      const s3Key = "Profile_Images/" + file.name;
      const s3Url = "https://tracechain-2026.s3.ap-south-1.amazonaws.com/" + s3Key;

      // 2. Build updated formData LOCALLY — state update is async so
      //    we can't rely on formData being updated before axios.put fires
      const updatedFormData = { ...formData, profileImg: s3Url };
      setFormData(updatedFormData);   // update UI state

      try {
        // 3. Upload to S3 and wait for it to finish
        await uploadFile(file, s3Key);

        // 4. Save the S3 URL to DB using the LOCAL updatedFormData (not stale formData)
        const response = await axios.put(
          config.API_ENDPOINT + "api/v1/user/" + id,
          updatedFormData,
          { headers: { "Content-Type": "application/json", "x-api-token": sessionStorage.getItem("traceChainAccessToken") } }
        );

        if (response.status === 200) {
          toast.success("Profile photo uploaded successfully!", {
            position: 'top-center',
            autoClose: 3000,
          });
        }
      } catch (err) {
        console.error("Photo upload failed:", err);
        toast.error("Failed to upload photo. Please try again.", {
          position: 'top-center',
          autoClose: 3000,
        });
      }
    };

    return (
        <div>
            <Navbar/>
            <div className="card2 m-5">
                <div className="card-body py-0">
                    <div className="row">
                        <div className="col-4">
                        {!formData.profileImg || formData.profileImg == null || formData.profileImg == undefined
                        || formData.profileImg == "" ? (
                            <img className="profile-img" src={imageSrc} alt="img"></img>
                        ):(
                          <img className="profile-img" src={formData.profileImg} alt="img"></img>
                          )
                        }
                            <br></br>
                            <br></br>
                            <input
                            type="file"
                            // name="profileImg"
                            accept="image/*"
                            // value={formData.profileImg}
                            onChange={handleImageUpload}
                            style={{ display: "none"}}
                            id="image-upload"
                            />
                            <label htmlFor="image-upload" className="btn btn-primary marginuploadImage">
                            Upload Image
                            </label>
                        </div>
                        
                        <div className="col-8 py-5 border-start">
                        <form onSubmit={handleFormSubmit}>
                            <div className="mb-3 row">
                                <label className="form-label fs-5 col-2">Name</label>
                                <input className="form-control fs-5 col-6 w-75" 
                                name="firstName"
                                value={`${formData.firstName} ${formData.lastName}`}
                                // value={formData.firstName} 
                                // onChange={handleInputChange} 
                                disabled
                                >
                                </input>
                            </div>
                            <div className="mb-3 row">
                                <label className="form-label fs-5 col-2">Email</label>
                                <input className="form-control fs-5 col-6 w-75" 
                                name="email"
                                value={formData.email} disabled>
                                </input>
                            </div>
                            <div className="mb-3 row">
                                <label className="form-label fs-5 col-2">Created At</label>
                                <input className="form-control fs-5 col-6 w-75" 
                                name="createdAt"
                                value={`${localDate1} ${localTime1}`}
                                disabled>
                                </input>
                            </div>
                            <div className="mb-3 row">
                                <label className="form-label fs-5 col-2">Time Zone</label>
                                <div className="form-control fs-5 col-6 w-75">
                                <TimezoneSelect
                                  name="timeZone"
                                  value={ {value: formData.timeZone }}
                                  onChange={handleTimezoneChange}
                                />
                                {/* <p>Selected Timezone: {selectedTimezone.label}</p> */}
                                </div>
                                {/* <div className="error-message">This field is editable!</div> */}
                            </div>
                            <div className="mb-3 row">
                                <label className="form-label fs-5 col-2">Contact</label>
                                <input 
                                className={`form-control fs-5 col-6 w-75 ${phoneNumberError ? 'is-invalid' : ''}`} style={{ marginTop:"10px"}}
                                // className="form-control fs-5 col-6 w-75" ${phoneNumberError ? 'is-invalid' : ''}`} 
                                name="phoneNumber"
                                value={formData.phoneNumber} 
                                onChange={handleInputChange}
                                // disabled
                                >
                                </input>
                                {phoneNumberError && (
                                  <div className="invalid-feedback" style={{ marginLeft:"16%"}}>{phoneNumberError}</div>
                                )}
                            </div>
                            <br></br>
                            {/* <br></br>
                            <br></br> */}
                            <div className="mb-3 row">
                            <div className="col-2"></div>
                            <div className="col-5 w-75">
                                <button type="submit" className="btn btn-primary marginSave">
                                Save Changes
                                </button>
                                <button onClick={Cancel} className="btn btn-primary marginSave">
                                  Cancel
                                </button>
                            </div>
                            <div id="confirmspin" className="loader" style={{ display: "none" }}>Loading...</div>
                            <ToastContainer/>
                            </div>
                    </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Profile;